<template>
  <swiper-slide>
    <div class="week-slider-text">
        {{dateString}}
    </div>
  </swiper-slide>
</template>
  
<script>
  // import { useEventsStore } from '@/store/events'

  export default {
    name: 'WeekSliderSlide',
    props: {
      start: Date,
      end: Date
    },
    computed:{
      dateString(){
        return this.dateToStr(this.start) + ' - ' + this.dateToStr(this.end)
      }
    },
    methods:{
      dateToStr(date){
        let monthDict = {
          0: 'янв',
          1: 'фев',
          2: 'мрт',
          3: 'апр',
          4: 'мая',
          5: 'июн',
          6: 'июл',
          7: 'авг',
          8: 'сен',
          9: 'окт',
          10: 'ноя',
          11: 'дек'
        }
        return date.getDate() + ' ' +monthDict[date.getMonth()]
      }
    }
  }
</script>